/**
 * @namespace P3.utils
 */
export {default as ObjectPool} from "./ObjectPool";

/**
 * Creates an identical copy of an object.
 * http://speakingjs.com/es5/ch17.html#code_copyOwnPropertiesFrom
 *
 * @param {Object} original
 * @param {boolean} [deep=true]
 * @returns {Object}
 */
export function copyObject(original, deep = true) {
    const copy = Object.create(Object.getPrototypeOf(original));
    copyOwnPropertiesFrom(copy, original, deep);
    return copy;
}

/**
 * Copies all of an object's properties to the target object.
 * http://speakingjs.com/es5/ch17.html#code_copyOwnPropertiesFrom
 *
 * @param {Object} target
 * @param {Object} source
 * @param {boolean} [deep=true]
 * @returns {Object}
 */
export function copyOwnPropertiesFrom(target, source, deep = true) {
    Object.getOwnPropertyNames(source)
        .forEach(function(key) {
            const descriptor = Object.getOwnPropertyDescriptor(source, key);
            Object.defineProperty(target, key, descriptor);
            if (deep && typeof descriptor.value === "object" && descriptor.value !== null) {
                target[key] = P3.utils.copyObject(source[key], deep);
            }
        });
    return target;
}

/**
 * Returns a value converted to a zero padded string.
 *
 * @param {number} n - The value to pad.
 * @param {number} [width=0] - The number of zeros to pad the string with.
 * @returns {string}
 */
export function padNum(n, width=0) {
    const num = Math.abs(n);
    const zeros = Math.max(0, width - Math.floor(num).toString().length);
    let zeroStr = Math.pow(10, zeros).toString().substr(1);
    if (num < 0) {
        zeroStr = "-" + zeroStr;
    }
    return zeroStr + num;
}

/**
 * @param {Array} arr
 * @returns {*}
 */
export function selectRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * @returns {boolean}
 */
export function isCocoonJS() {
    return (typeof navigator["isCocoonJS"] !== "undefined");
}